import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026" canonical="https://spherehyx.com/terms">
      <p>These Terms govern your use of SphereHyx. By creating an account, registering an athlete, or making a payment, you agree to these Terms and to our <a href="/privacy">Privacy Policy</a>.</p>

      <h2>Using SphereHyx</h2>
      <ul>
        <li>You must provide accurate information and keep your login secure.</li>
        <li>Clubs and coaches are responsible for the accuracy and lawful use of the data they add, including obtaining consent from parents/guardians for minors.</li>
        <li>Do not misuse the service, attempt to disrupt it, or use it for unlawful purposes.</li>
      </ul>

      <h2>Subscriptions</h2>
      <p>Paid plans (Pro and Club) are billed on a recurring basis via Stripe until cancelled. You can cancel anytime from your dashboard; access continues until the end of the current billing period. Fees already paid are non-refundable except as described below or as required by law.</p>

      <h2>Fees &amp; payments</h2>
      <p>Clubs may collect membership and activity fees through the platform. Payments are processed by Stripe. Funds for club fees are routed to the club's connected account; SphereHyx may retain a small platform fee.</p>

      <h2>Refunds — overcharges &amp; duplicate charges</h2>
      <ul>
        <li>If you are <b>charged twice for the same fee</b>, or <b>charged an incorrect (higher) amount</b>, you are entitled to a refund of the excess.</li>
        <li>Coaches/club admins can issue a refund directly from the <b>Payments</b> section by opening the affected payment and selecting <b>Refund</b>.</li>
        <li>If you can't reach your club, email <a href="mailto:support@spherehyx.com">support@spherehyx.com</a> with the payment details and we will help arrange the refund.</li>
        <li>Approved refunds are returned to the original payment method via Stripe, typically within 5–10 business days.</li>
      </ul>

      <h2>Liability</h2>
      <p>SphereHyx is provided "as is". To the fullest extent permitted by law, we are not liable for indirect or consequential losses. Clubs remain responsible for their own activities, safety and decisions.</p>

      <h2>Termination</h2>
      <p>You may stop using the service at any time. We may suspend or terminate accounts that violate these Terms.</p>

      <h2>Changes</h2>
      <p>We may update these Terms; material changes will be posted here with a new "last updated" date. Continued use means you accept the updated Terms.</p>
    </LegalLayout>
  );
}
